/**
 * Unique emoji (or 'custom') per badge. Big, pictorial, correlates to the badge meaning.
 * Used for the large "emoji on top" card style.
 */
export const BADGE_EMOJI = {
  agenda_starter: 'custom',  // custom "just starting" illustration in BadgeCard
  agenda_builder: '🏗️',     // building structure
  agenda_pro: '🎯',         // on target / pro
  decision_minded: '⚖️',   // weighing decisions
  scorecard_90: '🏆',      // trophy / ace
  scorecard_95: '💎',      // excellence / diamond
  scorecard_100: '💯',     // perfect 100
  outputs_all_closed: '✅', // follow-through complete
  meeting_centurion: '🏅', // century / centurion
  meeting_kilomeet: '🌌',  // cosmic scale — a thousand meets
  team_century_squad: '🤝', // squad milestone
  team_kilomeet_armada: '⚓', // fleet / armada
}

/** Accent for card gradient by category */
export const BADGE_ACCENT = {
  agenda: 'from-amber-400/20 to-orange-400/10',
  performance: 'from-emerald-400/20 to-teal-400/10',
  outputs: 'from-violet-400/20 to-purple-400/10',
  milestone: 'from-sky-400/20 to-indigo-400/10',
}

/** Reward-style perimeter: border + inner ring shadow by category */
export const BADGE_RING = {
  agenda:
    'border-2 border-amber-400/70 shadow-[inset_0_0_0_1px_rgba(251,191,36,0.35),0_2px_6px_rgba(0,0,0,0.07)] hover:shadow-[inset_0_0_0_1px_rgba(251,191,36,0.5),0_3px_10px_rgba(0,0,0,0.1)]',
  performance:
    'border-2 border-emerald-400/70 shadow-[inset_0_0_0_1px_rgba(52,211,153,0.3),0_2px_6px_rgba(0,0,0,0.07)] hover:shadow-[inset_0_0_0_1px_rgba(52,211,153,0.45),0_3px_10px_rgba(0,0,0,0.1)]',
  outputs:
    'border-2 border-violet-400/70 shadow-[inset_0_0_0_1px_rgba(139,92,246,0.35),0_2px_6px_rgba(0,0,0,0.07)] hover:shadow-[inset_0_0_0_1px_rgba(139,92,246,0.5),0_3px_10px_rgba(0,0,0,0.1)]',
  milestone:
    'border-2 border-sky-400/70 shadow-[inset_0_0_0_1px_rgba(56,189,248,0.35),0_2px_6px_rgba(0,0,0,0.07)] hover:shadow-[inset_0_0_0_1px_rgba(56,189,248,0.5),0_3px_10px_rgba(0,0,0,0.1)]',
}

export function getBadgeEmoji(badgeKey) {
  const v = BADGE_EMOJI[badgeKey]
  return v === 'custom' ? null : (v ?? '✨')
}

export function hasCustomIcon(badgeKey) {
  return BADGE_EMOJI[badgeKey] === 'custom'
}

export function getBadgeAccent(category) {
  return BADGE_ACCENT[category] ?? 'from-gray-400/20 to-gray-400/10'
}

export function getBadgeRing(category) {
  return BADGE_RING[category] ?? 'border-2 border-gray-300/50 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.06),0_2px_6px_rgba(0,0,0,0.07)]'
}
